// @ts-nocheck
import { toFleetScore } from './APITransformer';
import type { FleetScore } from './Types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class DriverScoreRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getFleetScore = (): Promise<FleetScore> => {
    const requestData: IRequest = {
      endpoint: '/dash/analytics',
      method: HttpMethod.GET,
    };
    // @ts-ignore
    return this.requester
      .request(requestData)
      .then((response) => toFleetScore(Object.values(response.data)[0]));
  };
}

export default DriverScoreRequester;
